const OAuthCallbackPage = () => {
    return (
        <div>
            <h1>OAuth Callback Page</h1>
        </div>
    );
}

export default OAuthCallbackPage;